module.exports = __webpack_public_path__ + "img/34.ab4bea67.jpg";